import { inject, Pipe, PipeTransform } from '@angular/core';
import { RemoteConfigKey } from '@marmon/shared/types/config';
import { ConfigService } from '../services';

@Pipe({ name: 'configValue' })
export class ConfigValuePipe implements PipeTransform {
	readonly config = inject(ConfigService);

	transform(key: RemoteConfigKey) {
		return this.config.getValue(key);
	}
}
